module.exports = __webpack_public_path__ + "static/img/sidebar-icon-transaction.c3bb4891.svg";